export default "__VITE_ASSET__C$b8_EN2__"